import { render } from "./grau.svg?vue&type=template&id=fa9ce052"
const script = {}

import exportComponent from "/Users/bornasepic/Desktop/projects/grau/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__